import React, { useEffect, useRef, useState } from 'react'
import './home.css'
import { THEMES } from '../../constatnts'
import Spacer from 'src/components/Spacer'
import PromoBlock from 'src/components/PromoBlock'
import CountUp from 'react-countup'
import { useIsInViewportOnce } from 'src/hooks'
import { useTranslation } from 'react-i18next'
import { NavButton } from 'src/components/navigation/nav'
import { Dialog, FormControl, IconButton, InputLabel, MenuItem, Select } from '@mui/material'
import { Form } from 'src/components/form'
import { StarsListMarker } from '../specialoffer'
import { useNavigate } from 'react-router-dom'
import Navigation from './navigation'
import Footer from './footer'

const Intersector = ({ children }) => {
  const someRef = useRef(null)
  const isInViewport = useIsInViewportOnce(someRef)

  return <div ref={someRef}>{isInViewport && children}</div>
}

const prices = [
  { value: 250, text: '£500K' },
  { value: 500, text: '£1M' },
  { value: 750, text: '£5M' },
  { value: 995, text: '£10M' },
  { value: 1495, text: '£25M' },
  { value: 2500, text: '£250M' },
  { value: 5000, text: '£250M+' }
]
const pricesEU = [
  { value: 300, text: '€1M' },
  { value: 600, text: '€5M' },
  { value: 900, text: '€10M' },
  { value: 1195, text: '€25M' },
  { value: 1795, text: '€100M' },
  { value: 2995, text: '€250M' },
  { value: 5995, text: '€250M+' }
]
const pricesUS = [
  { value: 1000, text: '$10M' },
  { value: 2000, text: '$25M' },
  { value: 3500, text: '$250M' },
  { value: 5000, text: '$500M' },
  { value: 10000, text: '$1B' }
]
const pricesCH = [
  { value: 280, text: 'CHF 1m' },
  { value: 550, text: 'CHF 5m' },
  { value: 850, text: 'CHF 10m' },
  { value: 1100, text: 'CHF 25m' },
  { value: 1650, text: 'CHF 100m' },
  { value: 2800, text: 'CHF 250m' },
  { value: 5600, text: 'CHF 250m+' }
]

const pricesSE = [
  { value: 3250, text: 'SEK 10m' },
  { value: 6500, text: 'SEK 50m' },
  { value: 9850, text: 'SEK 100m' },
  { value: 13000, text: 'SEK 275m' },
  { value: 19600, text: 'SEK 1100m' },
  { value: 32500, text: 'SEK 2750m' },
  { value: 65500, text: 'SEK 2750m+' }
]
const pricesIN = [
  { value: 50000, text: '250 Crores' },
  { value: 80000, text: '1000 Crores' },
  { value: 150000, text: '3000 Crores' },
  { value: 250000, text: '>3000 Crores' }
]

const countries = {
  uk: 'United Kingdom',
  eu: 'European Union',
  us: 'United States',
  se: 'Sweden',
  ch: 'Switzerland',
  in: 'India'
}

const pricesByLoc = {
  uk: prices,
  eu: pricesEU,
  us: pricesUS,
  se: pricesSE,
  ch: pricesCH,
  in: pricesIN
}

const currencies = {
  uk: '£',
  eu: '€',
  us: '$',
  se: 'SEK',
  ch: 'CHF',
  in: 'INR'
}

export const ActivatePage = ({ loc = 'uk', ishsbc = false }) => {
  const [price, setPrice] = React.useState(
    loc == 'in' ? 50000 : loc == 'se' ? 3250 : loc == 'ch' ? 280 : loc == 'eu' ? 300 : loc == 'us' ? 1000 : 250
  )

  const isEea = loc == 'se' || loc == 'eu'

  const registrationParams = new URLSearchParams({
    iseea: isEea,
    ...(ishsbc && { ishsbc: true }),
    country: countries[loc],
    turnover: pricesByLoc[loc]?.find(el => el.value == price)?.text || '',
    price: `${currencies[loc]} ${price}${['eu', 'uk'].includes(loc) ? ' +VAT' : ''}`
  }).toString()
  const registrationLink = `/activate/registration?${registrationParams}`

  const handleChange = event => {
    setPrice(event.target.value)
  }
  const isMobile = window.innerWidth < 768

  const { t } = useTranslation()
  const [requestDemoModalOpen, setRequestDemoModalOpen] = useState(false)

  useEffect(() => {
    requestDemoModalOpen ? (document.body.style.position = 'fixed') : (document.body.style.position = 'relative')
    requestDemoModalOpen ? (document.body.style.width = '100vw') : (document.body.style.width = '100%')
  }, [requestDemoModalOpen])

  const navigate = useNavigate()

  return (
    <div className={`activate-page ${ishsbc && ' hsbc-page'}`}>
      <Navigation
        theme={THEMES.dark}
        onOpenDemoModal={() => {
          navigate(registrationLink)
        }}
      />
      <section className='dark heading-section special-offer-page'>
        {!ishsbc && <div className='hide mob-show home-mob-main-img'></div>}
        <div className='container'>
          <div className='row row-center mob-column-reverse mob-column-center'>
            <div className='column main-left mob-fw'>
              <h1 className='lh11 mob-lh-12 mob-mb-30 '>Gallagher Cyber Defence Centre</h1>
              <p
                style={{ wordSpacing: 3, color: '#4A4A4A', maxWidth: '490px' }}
                className='fs20 mob-fs-18 mb40 mob-mb-50 lh16'
              >
                Protect your organisation with continuous cyber defence services, expert threat intelligence, and
                tailored security guidance.
              </p>
              <div className='row'>
                <p className='fs18 fw700 blue-text lh14 mb10' style={{ fontFamily: 'Roboto Slab' }}>
                  Vulnerability Scanning – <span className='fw400'>Identify critical weaknesses in your systems.</span>
                </p>
              </div>
              <div className='row'>
                <p className='fs18 fw700 blue-text lh14 mb10' style={{ fontFamily: 'Roboto Slab' }}>
                  Threat Intelligence Webinars –{' '}
                  <span className='fw400'>
                    Get monthly insights on emerging <br /> cyber threats.
                  </span>
                </p>
              </div>
              <div className='row'>
                <p className='fs18 fw700 blue-text lh14 mb10' style={{ fontFamily: 'Roboto Slab' }}>
                  Building Cyber Resilience Together –{' '}
                  <span className='fw400'>
                    Train employees to recognize <br /> and stop attacks.
                  </span>
                </p>
              </div>
              <div className='row'>
                <p className='fs18 fw700 blue-text lh14 mb10' style={{ fontFamily: 'Roboto Slab' }}>
                  Virtual CISO – <span className='fw400'>Access expert guidance from a security leader.</span>
                </p>
              </div>
              <div className='row mb50'>
                <p className='fs18 fw700 blue-text lh14 mb10' style={{ fontFamily: 'Roboto Slab' }}>
                  Cyber Risk Newsletter – <span className='fw400'>Stay updated with key threat intelligence.</span>
                </p>
              </div>

              <div className='w390 mob-fw column price-per-year mb50'>
                <FormControl sx={{ minWidth: 120, mb: '28px' }}>
                  <InputLabel id='demo-simple-select-helper-label' sx={{ color: '#0075BC', fontFamily: 'Roboto Slab' }}>
                    Turnover (upto)
                  </InputLabel>
                  <Select
                    labelId='demo-simple-select-helper-label'
                    id='demo-simple-select-helper'
                    value={price}
                    label='Turnover (upto)'
                    onChange={handleChange}
                    sx={{
                      color: '#0075BC',
                      fontFamily: 'Roboto Slab',
                      fontSize: '18px'
                    }}
                  >
                    {loc == 'uk' &&
                      prices.map(el => (
                        <MenuItem
                          key={el.value}
                          sx={{
                            color: '#0075BC',
                            fontFamily: 'Roboto Slab'
                          }}
                          value={el.value}
                        >
                          {el.text}
                        </MenuItem>
                      ))}
                    {loc == 'eu' &&
                      pricesEU.map(el => (
                        <MenuItem
                          key={el.value}
                          sx={{
                            color: '#0075BC',
                            fontFamily: 'Roboto Slab'
                          }}
                          value={el.value}
                        >
                          {el.text}
                        </MenuItem>
                      ))}
                    {loc == 'us' &&
                      pricesUS.map(el => (
                        <MenuItem
                          key={el.value}
                          sx={{
                            color: '#0075BC',
                            fontFamily: 'Roboto Slab'
                          }}
                          value={el.value}
                        >
                          {el.text}
                        </MenuItem>
                      ))}
                    {loc == 'se' &&
                      pricesSE.map(el => (
                        <MenuItem
                          key={el.value}
                          sx={{
                            color: '#0075BC',
                            fontFamily: 'Roboto Slab'
                          }}
                          value={el.value}
                        >
                          {el.text}
                        </MenuItem>
                      ))}
                    {loc == 'ch' &&
                      pricesCH.map(el => (
                        <MenuItem
                          key={el.value}
                          sx={{
                            color: '#0075BC',
                            fontFamily: 'Roboto Slab'
                          }}
                          value={el.value}
                        >
                          {el.text}
                        </MenuItem>
                      ))}
                    {loc == 'in' &&
                      pricesIN.map(el => (
                        <MenuItem
                          key={el.value}
                          sx={{
                            color: '#0075BC',
                            fontFamily: 'Roboto Slab'
                          }}
                          value={el.value}
                        >
                          {el.text}
                        </MenuItem>
                      ))}
                  </Select>
                </FormControl>
                <div className='row row-center'>
                  <p className='fs14' style={{ textTransform: 'uppercase', color: '#0075BC' }}>
                    {ishsbc ? 'Price for year 1' : 'Price Per year'}
                  </p>
                  <Spacer />
                  <p
                    className='fs24 fw700'
                    style={{ color: '#0075BC', textDecoration: ishsbc ? 'line-through' : null }}
                  >
                    {loc == 'in'
                      ? 'INR'
                      : loc == 'se'
                      ? 'SEK'
                      : loc == 'ch'
                      ? 'CHF'
                      : loc == 'eu'
                      ? '€'
                      : loc == 'us'
                      ? '$'
                      : '£'}{' '}
                    {price}
                    {['eu', 'uk'].includes(loc) && '+VAT'}
                  </p>
                </div>
              </div>

              <div className='row mob-fw'>
                <NavButton
                  self
                  fullwidth={isMobile}
                  to={registrationLink}
                  variant='dark'
                  size='md'
                >
                  Activate
                </NavButton>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className='header-to-dark darker padding140-150 mob-padding-54-35 box-shadow'>
        <div className='container'>
          <div className='column column-center'>
            <h2 className='text-center mb100 mob-mb-73 mw900 mob-mw341 mob-sato-26'>{t('home.setction2title')}</h2>
          </div>
          <div className='row space-between mob-column mob-margin-0'>
            <div className='column column-start one-of-4 mob-fullwidth mob-mb-40' style={{ maxWidth: 205 }}>
              <div className='gradient-text text-center big-num '>
                <Intersector>
                  <CountUp end={93} />%
                </Intersector>
              </div>
              <p className='font20 mob-font14 mob-font500 lh12 mw279'>{t('home.setction2text1')}</p>
            </div>

            <div className='column column-start one-of-4 mob-fullwidth mob-mb-40' style={{ maxWidth: 205 }}>
              <div className='gradient-text text-center big-num '>
                <Intersector>
                  <CountUp end={82} />%
                </Intersector>
              </div>
              <p className='font20 mob-font14 mob-font500 lh12 mw339 mob-mw299'>{t('home.setction2text2')}</p>
            </div>

            <div className='column column-start one-of-4 mob-fullwidth mob-mb-20' style={{ maxWidth: 205 }}>
              <div className='gradient-text text-center big-num '>
                <Intersector>
                  <CountUp duration={3} end={30} />%
                </Intersector>
              </div>
              <p className='font20 mob-font14 mob-font500 lh12 mw279 mob-mw245'>{t('home.setction2text3')}</p>
            </div>

            <div className='column column-start one-of-4 mob-fullwidth mob-mb-20' style={{ maxWidth: 205 }}>
              <div className='gradient-text text-center big-num '>
                <Intersector>
                  $<CountUp duration={3} end={4} />
                  .45M
                </Intersector>
              </div>
              <p className='font20 mob-font14 mob-font500 lh12 mw279 mob-mw245'>{t('home.setction2text4')}</p>
            </div>
          </div>
        </div>
      </section>

      <section className='dark pt120 pb50'>
        <div className='container'>
          <div className='column'>
            <div className=' mb40 mob-mb-20 content-box secure-humans-backgound'>
              <div className='row row-center space-between mob-column'>
                <div className='hide mob-show' style={{ height: 230 }}></div>
                <Spacer />
                <div className='mob-mb-20 one-of-2 mob-fullwidth content-box-text'>
                  <h3 style={{ maxWidth: '419px', fontFamily: 'Roboto Slab' }} className='mob-font-20'>
                    Building Cyber Resilience Together
                  </h3>
                  <div className='title-underline'></div>
                  <p className='font18-400  mob-mb-20' style={{ color: '#4A4A4A', fontFamily: 'Source Sans 3' }}>
                    The biggest contributor to a cyber incident is human vulnerability. Each month we will host a series
                    of cybersecurity training webinars designed for your employees at all levels of understanding.
                    Throughout the year, your staff can be trained by our specialist cybersecurity team in the role they
                    can play in defending your organisation. Topics will include boundary control, email security and
                    phishing, working from home, data protection and more.
                  </p>
                </div>
              </div>
            </div>

            <div className='row mob-column' style={{ gap: 40, marginBottom: 40 }}>
              <div className='  content-box one-of-2 mob-fullwidth'>
                <div className='row row-center space-between mob-column'>
                  <div className=' '>
                    <h3 style={{ maxWidth: '419px', fontFamily: 'Roboto Slab' }} className='mob-font-20'>
                      Continuous Vulnerability Scanning
                    </h3>
                    <div className='title-underline'></div>
                    <p className='font18-400  ' style={{ color: '#4A4A4A', fontFamily: 'Source Sans 3' }}>
                      Our Cyber Defence team will monitor your external boundaries and provide you updates as to the
                      known vulnerabilities with your technology portfolio. This report will outline where your low,
                      medium and high risk technology vulnerabilities reside.
                    </p>
                  </div>
                </div>
              </div>

              <div className='  content-box one-of-2 mob-fullwidth'>
                <div className='row row-center space-between mob-column-reverse'>
                  <div className=' '>
                    <h3 style={{ maxWidth: '419px', fontFamily: 'Roboto Slab' }} className='mob-font-20'>
                      Threat Intelligence Webinars
                    </h3>
                    <div className='title-underline'></div>
                    <p className='font18-400  ' style={{ color: '#4A4A4A', fontFamily: 'Source Sans 3' }}>
                      Forewarned is forearmed. As a cyber-insurance broker we deal with a huge amount of claims, and
                      from this, we gain extensive intelligence on the latest threats and methods of attack. We can
                      provide real-time updates on where your organisation needs to be focusing its cyber defence
                      efforts.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className=' mb40 mob-mb-20 content-box newsletter-backgound'>
              <div className='row row-center space-between mob-column'>
                <div className='hide mob-show' style={{ height: 260 }}></div>
                <div className='mob-mb-20 one-of-2 mob-fullwidth mob-content-box-text'>
                  <h3 style={{ maxWidth: '419px', fontFamily: 'Roboto Slab' }} className='mob-font-20'>
                    Gallagher Cyber Risk Matters Newsletter
                  </h3>
                  <div className='title-underline'></div>
                  <p className='font18-400  mob-mb-20' style={{ color: '#4A4A4A', fontFamily: 'Source Sans 3' }}>
                    We will send you regular email updates on the latest cyber thinking so that you can stay informed.
                    We are in the age of information, and these key insights can support you to make key changes and
                    adaptions to your security efforts.
                  </p>
                </div>
              </div>
            </div>

            <div className=' mb40 mob-mb-20 content-box virtual-cisco-backgound'>
              <div className='row row-center space-between mob-column'>
                <div className='hide mob-show' style={{ height: 230 }}></div>
                <Spacer />
                <div className='mob-mb-20 one-of-2 mob-fullwidth content-box-text'>
                  <h3 style={{ maxWidth: '419px', fontFamily: 'Roboto Slab' }} className='mob-font-20'>
                    Virtual CISO
                  </h3>
                  <div className='title-underline'></div>
                  <p className='font18-400  mob-mb-20' style={{ color: '#4A4A4A', fontFamily: 'Source Sans 3' }}>
                    Gain access to a Virtual Chief Information Security Officer (CISO) who will provide guidance and
                    support. Leverage their expertise to assess your current cybersecurity posture, develop strategies,
                    and address any concerns or questions you may have.
                  </p>
                </div>
              </div>
            </div>

            <div className='row mob-column' style={{ gap: 40, marginBottom: 40 }}>
              <div className='content-box one-of-2 mob-fullwidth'>
                <div className='row row-center space-between mob-column'>
                  <div className=' mob-fullwidth'>
                    <h3 style={{ maxWidth: '419px', fontFamily: 'Roboto Slab' }} className='mob-font-20'>
                      Cyber Essentials
                    </h3>
                    <div className='title-underline'></div>
                    <p className='font18-400  ' style={{ color: '#4A4A4A', fontFamily: 'Source Sans 3' }}>
                      Through Gallagher, you can take advantage of lower prices on Cyber Essentials and IASME
                      accreditation. Cyber Essentials is the government-backed information security standard that offers
                      70+ controls to better secure your network.
                    </p>
                  </div>
                </div>
              </div>

              <div className='content-box one-of-2 mob-fullwidth'>
                <div className='row row-center space-between mob-column-reverse'>
                  <div className=' mob-fullwidth'>
                    <h3 style={{ maxWidth: '419px', fontFamily: 'Roboto Slab' }} className='mob-font-20'>
                      Community Intelligence
                    </h3>
                    <div className='title-underline'></div>
                    <p className='font18-400  ' style={{ color: '#4A4A4A', fontFamily: 'Source Sans 3' }}>
                      You will be part of a community of security professionals where your contribution counts. You will
                      be invited to monthly discussions about key security concerns and live threats your organisation
                      needs to be aware of. We will be bringing forward thought leadership and solutions for network
                      configuration, technology optimisation, risk management and risk transfer. As a collective, we are
                      stronger together in the offensive efforts against cyber criminals.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className=' mb40 mob-mb-20 content-box other-services-backgound'>
              <div className='row row-center space-between mob-column'>
                <div className='hide mob-show' style={{ height: 270 }}></div>
                <div className='mob-mb-20 one-of-2 mob-fullwidth content-box-text'>
                  <h3 style={{ fontFamily: 'Roboto Slab' }} className='mob-font-20'>
                    Other Security Services
                  </h3>
                  <div className='title-underline'></div>
                  <p className='font18-400  mob-mb-20' style={{ color: '#4A4A4A', fontFamily: 'Source Sans 3' }}>
                    Take advantage of the wider security services the Gallagher Cyber Risk Management Practice provides,
                    and receive preferential pricing as a Gallagher Cyber Defence Centre member. Services such as
                    penetration testing, phishing simulations, ISO27001, incident response planning, maturity
                    assessments and more, are all available to you when you become part of our community.
                  </p>
                </div>
                <Spacer />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className='dark pb150 mob-pb-20'>
        <PromoBlock onModalOpen={() => navigate(registrationLink)} buttonText={'GET STARTED'}>
          <p className='sato34 mb36 font500 mob-mw263 mob-font-24'>
            {t('Start your journey with Gallagher. Connect with an expert')}.
          </p>
        </PromoBlock>
      </section>

      <Footer theme={THEMES.dark} />
    </div>
  )
}
